import { render, staticRenderFns } from "./details-item.vue?vue&type=template&id=77c396c8"
import script from "./details-item.vue?vue&type=script&lang=js"
export * from "./details-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports